// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__1sQBr","rotate":"Loader_rotate__2LmuI","dash":"Loader_dash__2lT40"};